import styled from '@emotion/styled'
import Column from 'components/core/Column'
import { SPACING } from 'constants/spacing.constants'

export const LoginFormSection = styled(Column)`
    width: 100%;
    align-items: center;
    row-gap: ${SPACING.p2};
`
